import React from 'react'
import moment from 'moment';

export const FJSSummary = ({fjStory}) => {
  return (
    <>
      <div className=''>
        <div className=''>{fjStory.title}</div>
        <div className=''>{fjStory.content}</div>
        <div className=''>Posted by: {fjStory.userName}</div>
        <div className=''>{moment(fjStory.createdAt.toDate()).calendar()}</div>
      </div>
    </>
  )
}
